import React from 'react'
import { Row, Col } from 'reactstrap'
import { Button } from '@/components/button'
import { NumericInput } from '@/components/inputs'
import { DatePicker } from '@/components/DatePicker'
import { BsrsGrid, Column, DateCell, DateFilterCell } from '@/components/BsrsGrid'
import { GridCell } from '@progress/kendo-react-grid'
import { TdActions } from '@/components/tdActions'
import Icon from '@/components/Icon'
import LoadingIndicator from '@/components/LoadingIndicator'
import isEnterPressed from '@/utils/isEnterPressed'
import { ValidationBoundary, Validator, ValidationState } from '@/components/validation'

import Resx from '@/components/Resx'

const deleteCommandCell = (props) => {
  return class AddCommandCell extends GridCell {
    render () {
      return <TdActions>
        <button className='btn-icon' disabled={props.disabled} onClick={() => props.onDelete(this.props.dataIndex - 1)}><Icon name='x' /></button>
      </TdActions>
    }
  }
}

const validateNumeric = ({ value }) => {
  if (typeof value !== 'number') {
    if (isNaN(Number(value))) {
      return 'Validations.InvalidNumber'
    }
  }
}
export class EditCycleParametersContent extends React.Component {
  constructor (props, context) {
    super(props, context)

    this._wrapper = React.createRef()
    this.state = {
      date: null,
      week: null
    }
  }

  addDate () {
    this.props.onAddDate(this.state.date)
    this.setState({ date: null })
  }

  addWeek () {
    this.props.onWeekAdd(this.state.week)
    this.setState(
      { week: null },
      () => this._wrapper.current && this._wrapper.current.querySelector('input').focus()
    )
  }

  handleWeekKeyDown (isValid, e) {
    if (isValid && isEnterPressed(e)) {
      e.target.blur()
      this.addWeek()
    }
  }

  renderDatesGrid () {
    if (this.props.dates.length > 0) {
      const { localize, disabled } = this.props
      return (
        <BsrsGrid
          simpleView
          items={this.props.dates.map(x => ({ date: x }))}>
          <Column field='date' title={localize('Common.Date')} filter='date' cell={DateCell} filterCell={DateFilterCell} editor='date' />
          <Column cell={deleteCommandCell({ disabled, localize, onDelete: index => this.props.onRemoveDateAt(index) })} width='50px' editable={false} />
        </BsrsGrid>
      )
    }
    return null
  }

  renderWeeksGrid () {
    if (this.props.weeks.length > 0) {
      const { localize, disabled } = this.props
      return (
        <BsrsGrid
          simpleView
          items={this.props.weeks.map(x => ({ week: x }))}>
          <Column field='week' title={localize('Reporting.Week')} />
          <Column cell={deleteCommandCell({ disabled, localize, onDelete: index => this.props.onRemoveWeekAt(index) })} width='50px' editable={false} />
        </BsrsGrid>
      )
    }
    return null
  }

  render () {
    if (this.props.loading === true) {
      return <LoadingIndicator />
    }
    const { disabled } = this.props
    return (
      <React.Fragment>
        <div className='two-sided-picker'>
          <Row>
            <Col lg='6'>
              <div className='box-header'><span><Resx name='Reporting.Dates' /></span></div>
              <div className='add-new-date'>
                <DatePicker
                  disabled={disabled}
                  value={this.state.date}
                  onChange={value => this.setState({ date: value })}
                />
                <Button
                  color='primary'
                  disabled={this.state.date === null || disabled}
                  className='btn btn-sm'
                  onClick={() => this.addDate()}
                  icon='plus'>
                  <Resx name='Common.Add' />
                </Button>
              </div>
              <div style={{ height: 300, overflowY: 'scroll', marginTop: 10 }}>
                {this.renderDatesGrid()}
              </div>
            </Col>
            <Col lg='6'>
              <div className='box-header'><span><Resx name='Reporting.Weeks' /></span></div>
              <ValidationBoundary>
                <div className='add-new-week' ref={this._wrapper}>
                  <Validator name='workflowDefinition' value={this.state.week} min={1} max={54} required onValidate={validateNumeric}>
                    <ValidationState render={({ isValid }) =>
                      <NumericInput
                        style={{ width: '100%' }}
                        integerOnly
                        disabled={disabled}
                        onKeyDown={e => this.handleWeekKeyDown(isValid, e)}
                        value={this.state.week}
                        onChange={week => this.setState({ week })}
                      />
                    } />
                  </Validator>
                  <ValidationState render={({ isValid }) =>
                    <Button
                      color='primary'
                      disabled={!isValid || disabled}
                      className='btn btn-sm'
                      onClick={() => this.addWeek()}
                      icon='plus'>
                      <Resx name='Common.Add' />
                    </Button>
                  } />
                </div>
              </ValidationBoundary>
              <div style={{ height: 300, overflowY: 'scroll', marginTop: 10 }}>
                {this.renderWeeksGrid()}
              </div>
            </Col>
          </Row>
        </div>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/dialogs/editCycleParameters/content.js